import { get } from 'lodash';

import * as CONSTANTS from '../../constants';

const initialState = {
  version: {
    data: null,
    isLoading: false,
    error: null,
  },
  authSchemes: {
    data: null,
    isLoading: false,
    error: null,
  },
  publicKey: {
    data: null,
    isLoading: false,
    error: null,
    uuid: null,
  },
  authentication: {
    data: null,
    isLoading: false,
    error: null,
  },
}

export default function (state = initialState, action){
  switch (action.type) {
    case CONSTANTS.VERSION_REQUEST:
      return { ...state, version: { isLoading : true, data: null, error: null } };
    case CONSTANTS.VERSION_SUCCESS:
      return { ...state, version: {
        data: action.payload.version, isLoading : false, error: null,
      } };
    case CONSTANTS.VERSION_ERROR:
      return { ...state, version: { error: action.payload, data: null, isLoading: false } };

    case CONSTANTS.PUBLIC_AUTH_SCHEMES_LIST_REQUEST:
      return { ...state, authSchemes: { isLoading : true, data: null, error: null } };
    case CONSTANTS.PUBLIC_AUTH_SCHEMES_LIST_SUCCESS:
      return { ...state, authSchemes: {
        data: action.payload, isLoading : false, error: null,
      } };
    case CONSTANTS.PUBLIC_AUTH_SCHEMES_LIST_ERROR:
      return { ...state, authSchemes: { error: action.payload, data: null, isLoading: false } };

    case CONSTANTS.GET_AUTH_SCHEME_PUBLIC_KEY_REQUEST:
      return { ...state, publicKey: {
        isLoading : true, data: null, error: null, uuid: action.payload.uuid,
      } };
    case CONSTANTS.GET_AUTH_SCHEME_PUBLIC_KEY_SUCCESS:
      return { ...state, publicKey: {
        data: action.payload.data, isLoading : false, error: null, uuid: action.payload.uuid,
      } };
    case CONSTANTS.GET_AUTH_SCHEME_PUBLIC_KEY_ERROR:
      return { ...state, publicKey: {
        error: action.payload.error, data: null, isLoading: false, uuid: action.payload.uuid,
      } };

    case CONSTANTS.AUTHENTICATE_LOGIN_REQUEST:
      return { ...state, authentication: { isLoading : true, data: null, error: null } };
    case CONSTANTS.AUTHENTICATE_LOGIN_SUCCESS:
      return { ...state, authentication: {
        data: action.payload, isLoading : false, error: null,
      } };
    case CONSTANTS.AUTHENTICATE_LOGIN_ERROR:
      return { ...state, authentication: {
        error: action.payload, data: null, isLoading: false,
      } };

    default:
      return state;
  }
}

export const getVersionData = state => get(state, 'login.version');
export const getAuthSchemesData = state => get(state, 'login.authSchemes');
export const getAuthSchemePublicKey = state => get(state, 'login.publicKey');
export const getAuthenticationData = state => get(state, 'login.authentication')